import { Component, OnInit, ViewChild } from "@angular/core";
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { TokenStorageService } from "../_services/token-storage.service";
import { AuthService } from "../_services/auth.service";
import {
  FormBuilder,

  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { Router } from "@angular/router"; 
import { ServicioGeneral } from "../_services/servicio-general.service";
import { NotificationService } from "../_services/notification.service";
import { UserService } from "../_services/user.service";
import { firstValueFrom } from "rxjs";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { MatLegacyPaginator as MatPaginator } from "@angular/material/legacy-paginator";
import { MatSort } from "@angular/material/sort";
import { Direccione } from "../model/third_model";
import { RaizComponent } from "../raiz/raiz.component";
import { ConfirmarCorreoService } from "../_services/confirmar-correo.service";
import { ConfirmDeleteDialogComponent } from "../modal/confirm-delete/confirm-delete-dialog.component";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ConfirmOtpDialogComponent } from "../modal/confirm-otp/confirm-otp-dialog.component";
import { NotificationI18nService } from '../core/util/notification-i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ClientLoaderService } from '../core/util/client-loader.service';
import { buildOtpAuthUri, buildQrImageUrl, resolveTwoFactorQrImageUrl, TwoFactorQrPayload } from '../core/util/two-factor-qr.util';


@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent extends UnsubscribeOnDestroy implements OnInit {

  constructor(
    private token: TokenStorageService,
    private _authService: AuthService,
    private _usuarioService: UserService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _servicioGeneral: ServicioGeneral,
    private _notificationI18n: NotificationI18nService,
    private userService: UserService,
    private raiz: RaizComponent,
    private _confirmacionCorreo: ConfirmarCorreoService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private clientLoader: ClientLoaderService,
  ) {
    super();
  }
  displayedColumns: string[] = ['id', 'nombre', 'Acciones'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  //Variables
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = "";
  currentUser = this.token.getUser();
  email : string = this.currentUser.email;
  editandoMail: boolean = false;
  errorQR: boolean = false;
  tfActivated: boolean = false;
  isShown: boolean = false;
  loading: boolean = false;
  update: boolean = false;
  submitted: boolean = false;
  newdirection: boolean = false;
  qr: TwoFactorQrPayload | null = null;
  qrImageUrl = '';
  TPersonas: any = [];
  TDocumentos: any = [];
  userFormDirecciones: Array<any> = [];
  numeroDirecciones: number = 0;
  TComunidades: any = [];
  TProvincias: any = [];
  provincias = this._servicioGeneral.getProvincias();
  TMunicipios: any = [];
  municipios = this._servicioGeneral.getMunicipios();
  TVias: any = [];
  TPais: any = [];
  direccion: Direccione | undefined ;
  dataSourceRepresento = new MatTableDataSource<any>();
  dataSourceMeRepresenta = new MatTableDataSource<any>();
  dataSourcePendienteMeRepresenta = new MatTableDataSource<any>();
  dataSourceSearchUser = new MatTableDataSource<any>();
  documentSearch;
  blockEnvioCorreo: boolean = false;

  checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => { 
    let password = group.get('password').value;
    let confirmPassword = group.get('password_confirmacion').value
    return password === confirmPassword ? null : { notSame: true }
  }

  form: FormGroup = new FormGroup( {
    nombre_responsable: new FormControl({value:"", disabled: true}), 
    numero_documento_responsable: new FormControl({value:"", disabled:true}),
    apellido1_responsable: new FormControl({value:"", disabled:true}),
    apellido2_responsable: new FormControl({value:"", disabled: true}),
    tipo_persona_responsable: new FormControl({value:"", disabled: true}),
    tipo_documento_responsable : new FormControl({value:"", disabled: true}),
    nombre: new FormControl({value:"", disabled: true}, Validators.required), 
    apellido1: new FormControl({value:"", disabled: true}, Validators.required),
    apellido2: new FormControl({value:"", disabled: true}),
    tipo_persona: new FormControl({value:"", disabled: true}, Validators.required),
    tipo_documento : new FormControl({value:"", disabled: true}, Validators.required),
    telefono : new FormControl("", [Validators.required, Validators.pattern("^[6,7]{1}[0-9]{8}")]),
    numero_documento : new FormControl({value:"", disabled: true}, Validators.required),
    tipo_via: new FormControl("", Validators.required),
    nombre_via: new FormControl("", Validators.required),
    numero_via: new FormControl("", Validators.required),
    bloque: new FormControl(""),
    escalera: new FormControl(""),
    piso: new FormControl(""),
    puerta: new FormControl(""),
    codigo_postal: new FormControl("", [Validators.required, Validators.pattern("^(?:0[1-9]\\d{3}|[1-4]\\d{4}|5[0-2]\\d{3})$")]),
    pais: new FormControl("", Validators.required),
    ccaa: new FormControl("", Validators.required),
    provincia: new FormControl("", Validators.required),
    municipio: new FormControl("", Validators.required),
  }, {});

  form2: FormGroup = new FormGroup({});

  form3: FormGroup = new FormGroup({
    totpkey: new FormControl("", [Validators.required, Validators.minLength(6), Validators.maxLength(6)])
  });

  //Init
  ngOnInit(): void {
    //this.token.saveUser();
    this.getDocumentos();
    this.getTipoPersona();
    this.getVias();
    this.getPais();
    this.getComunidades();
    this.getProvincias();
    this.userData();
    this.update = false;

    if(this.currentUser.tfa && this.currentUser.tfa != "disabled"){
      this.tfActivated = true;
    } 

    
  }

  //Funciones
  nuevaDireccion() {
    let auxDirection: Direccione = undefined;
    this.userFormDirecciones.push(auxDirection);
  }


  getFirstLetter(nombre: string) {
    return nombre.charAt(0).toUpperCase();
  }

  userData():void {
    if(this.currentUser.email==null){
      this.form.addControl("email", new FormControl("",[ Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$') ]));
      this.form.addControl("password", new FormControl("", [Validators.minLength(6)]));
      this.form.addControl("password_confirmacion", new FormControl(""));
      // this.form.addValidators(this.checkPasswords);
    }
    else{
      this.form.addControl("email", new FormControl("", Validators.required));

      this.form.patchValue({
        email: (this.currentUser.email) ? this.currentUser.email : ''
      });
    }

    this.form.patchValue({
      tipo_persona: (this.currentUser.tipopersona) ? this.currentUser.tipopersona["id"] : '',
      nombre: this.currentUser.nombre,
      apellido1: this.currentUser.apellido1,
      apellido2: this.currentUser.apellido2,
      telefono: (this.currentUser.telefono) ? this.currentUser.telefono : '',
      tipo_documento: (this.currentUser.tipo_documento) ? this.currentUser.tipo_documento["id"] : '',
      numero_documento: (this.currentUser.numero_documento) ? this.currentUser.numero_documento : '',
    });
    if(this.currentUser.usuarioRepresenta && this.currentUser.tipopersona.id == 2){  
      this.form.patchValue({
        tipo_persona_responsable: (this.currentUser.usuarioRepresenta.tipopersona) ? this.currentUser.usuarioRepresenta.tipopersona["id"] : '1',
        nombre_responsable: this.currentUser.usuarioRepresenta.nombre ?? '',
        apellido1_responsable: this.currentUser.usuarioRepresenta.apellido1,
        apellido2_responsable: this.currentUser.usuarioRepresenta.apellido2,
        tipo_documento_responsable: (this.currentUser.usuarioRepresenta.tipo_documento) ? this.currentUser.usuarioRepresenta.tipo_documento.id : '1',
        numero_documento_responsable: (this.currentUser.usuarioRepresenta.numeroDocumento) ? this.currentUser.usuarioRepresenta.numeroDocumento : '',
      })
    }
    
    if (this.currentUser.direcciones.length != 0) {
      this.direccion=this.currentUser.direcciones[0];
      this.getMunicipios();
      this.form.patchValue({
        tipo_via: this.direccion?.type_of_road.id??'',
        nombre_via: this.direccion?.name_road??'',
        numero_via: this.direccion?.number_road??'',
        bloque: this.direccion?.block??'',
        escalera: this.direccion?.stairs??'',
        piso: this.direccion?.floor??'',
        puerta: this.direccion?.door??'',
        codigo_postal: this.direccion?.postal_code??'',
        pais: this.direccion?.country.id??'',
        ccaa: this.direccion?.ccaa.id??'',
        provincia: this.direccion?.province.id??'',
        municipio: this.direccion?.municipality??'',
        isactive: this.direccion?.isActive
      });
    } 
    
    /*else {
      this.nuevaDireccion();
      this.newdirection = !this.newdirection;
    }*/
    if(this.currentUser.email==null){
      this._notificationI18n.warning('COMMON.PROFILE_INCOMPLETE');
    }
  // this.consultarStatus();
  //this.getRepresentedUsers();

  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    this.update = false;


    if(this.form.get('codigo_postal').hasError('pattern')){
      this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_ES_UN_CODIGO_POSTAL_VALIDO', 5000);
      return false;
    }

    console.log("Current user: ", this.currentUser);
    

    if(this.currentUser.email==null){
      if(this.form.get('password').hasError('minLength')){
        this._notificationI18n.error('NOTIFICATION.MESSAGE.LA_CONTRASENA_DEBE_TENER_AL_MENOS_6_CARACTERES', 5000);
        return false;
      }
  
      if(this.form.hasError('notSame')){
        this._notificationI18n.error('NOTIFICATION.MESSAGE.LAS_CONTRASENAS_NO_COINCIDEN', 5000);
        this.form.controls['password_confirmacion'].setErrors({'incorrect': true});
        return false;
      }
    }

    if(!this.form.valid) {
      console.log("Entro al if de formulario no válido");
      
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {

      if((this.currentUser.email != null 
        && this.currentUser.email !== this.form.value.email) 
        &&(this.currentUser.telefono != null && this.currentUser.telefono !== this.form.value.telefono )){
          this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_ES_POSIBLE_CAMBIAR_EL_MOVIL_Y_EL_EMAIL_A_LA_VEZ', 5000);
          return false;
      }
      else if(this.currentUser.email != null    && this.currentUser.email !== this.form.value.email){
        this.openValidateOtpMailDialog('MOVIL');
      }
      else if(this.currentUser.telefono != null && this.currentUser.telefono !== this.form.value.telefono ){
        this.openValidateOtpMailDialog('MAIL');
      }
      else{
        console.log("Entro al else");
        
        this._authService.updateUser(this.form.value)
          .pipe(takeUntil(this.destroy$))
          .subscribe({  
          next: async data => {
            if(this.currentUser.email == null){
              this._notificationI18n.info('NOTIFICATION.MESSAGE.SE_HA_ENVIADO_UN_MENSAJE_DE_CONFIRMACION_A_SU_CORREO_ELECTRONICO', 50000);          
            } else {
              this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_ACTUALIZADO_CON_EXITO', 50000);          
            }
            
            this.token.saveToken(data.accessToken);
            this._usuarioService.getCurrentUserFromServer()
              .pipe(takeUntil(this.destroy$))
              .subscribe({
              next: async data => { 
                this.token.setUser(data.Usuario,data.usuarioRepresenta);
                
                this.isSignUpFailed = false;
                this.update = true;
                this.raiz.reloadHeader=!this.raiz.reloadHeader; 

                let reload = this._router.url.includes('action')?this._router.url.slice(1):this._router.url.slice(1).concat('?action=20')
                this._router.navigate(['inicio'], { skipLocationChange: true }).then(() => {
                  this._router.navigateByUrl(reload);
                });
                
              },
              error: err => {
                this.update = false;
                
                if(err.status == 226){
                  this._notificationI18n.errorDynamic(err.error.text, 50000);
                  this.form.controls['numero_documento'].setErrors({'incorrect': true});
                } 
      
                if(err.status == 406){
                  this._notificationI18n.errorDynamic(err.error , 50000);
                  this.form.controls['numero_documento'].setErrors({'incorrect': true});
                }
      
                if(err.error.status == 628){
                  this._notificationI18n.errorDynamic(err.error , 50000);
                  this.form.controls['email'].setErrors({'incorrect': true});
                }
      
                if(err.error.status == 627){
                  this._notificationI18n.errorDynamic(err.error , 50000);
                  this.form.controls['email'].setErrors({'incorrect': true});
                }
                this.isSignUpFailed = true;
              }
            });
          
          },
          error: err => {
            console.log("Error: ", err);

            this.update = false;
            
            if(err.status == 226){
              this._notificationI18n.errorDynamic(err.error.text, 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            } 

            if(err.status == 406){
              this._notificationI18n.errorDynamic(err.error , 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            }

            if(err.error.status == 628){
              this._notificationI18n.errorDynamic(err.error , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }

            if(err.error.status == 627){
              this._notificationI18n.errorDynamic(err.error , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }
            this.isSignUpFailed = true;
          }
        });
      }
    }
  }

  searchUser(): any {
    /*this._authService.getUserData()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
         data;
        firstValueFrom(this.userService.getCurrentUserRepresented()).then((dataRepresented) => {
          this.currentUser.representados = dataRepresented.representa
          this.currentUser.esRepresentado = dataRepresented.representado_por
        })
      },
      error: (error) => {
        //console.log(error);

      }
    })*/
  }


  cerrarActivacion2FA(): void {
    this.isShown = false;
    this.loading = false;
    this.errorQR = false;
    this.qr = null;
    this.qrImageUrl = '';
    this.form3.reset();
  }

  pedirQR(): void {
    this.loading = true;
    this.errorQR = false;
    this._authService.pedirQr()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.qr = data;
        this.refreshQrImageUrl();
        this.isShown = true;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.errorQR = true;
      }
    });
  }

  onQrImageError(): void {
    if (!this.qr?.secret) {
      return;
    }
    const issuer = this.clientLoader.getConfigSync('title-head', 'OficinaVirtual');
    const otpauthUri = this.qr.otpauthUri || buildOtpAuthUri(this.qr.secret, this.currentUser?.email, issuer);
    this.qrImageUrl = buildQrImageUrl(otpauthUri);
  }

  private refreshQrImageUrl(): void {
    const issuer = this.clientLoader.getConfigSync('title-head', 'OficinaVirtual');
    this.qrImageUrl = resolveTwoFactorQrImageUrl(this.qr, this.currentUser?.email, issuer);
  }

  guardarQR(): void {
    const code = (this.form3.get('totpkey')?.value ?? '').toString().trim();
    if (code.length < 6) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_NO_ES_CORRECTO', 5000);
      return;
    }

    this._authService.guardarQR(this.qr!.secret!, code)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        if (data?.result === 'success') {
          this.tfActivated = true;
          this.errorQR = false;
          this.isShown = false;
          this.currentUser = { ...this.currentUser, tfa: data.secret };
        } else {
          this.qr = data;
          this.refreshQrImageUrl();
          this.errorQR = true;
          this.form3.reset();
        }
      },
      error: (err) => {
        if (err.error?.secret) {
          this.qr = err.error;
          this.refreshQrImageUrl();
        }
        this.errorQR = true;
        this.form3.reset();
        if(err.error.codigo == 637){
          this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_CODIGO_NO_ES_CORRECTO', 50000);      
        }  
        else{
          this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_ACTIVAR_2FA', 50000);      

        }
      }
    });
  }

  quitarQR(): any {
    this._authService.quitarQR(false)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.qr = data;
        if (this.isShown) {
          !this.isShown;
        }
        this.tfActivated = false;
        this.form3 = this._formBuilder.group({
          totpkey: [""],
        });
      },
      error: (err) => {
        //console.log(err);
      }
    })
  }

  reenviarCorreo(): any {
    this.blockEnvioCorreo = true;
    this._confirmacionCorreo.getEmailConfirmacion(this.currentUser.email)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this._confirmacionCorreo.reenviarCorreo(data.token)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
          next: (data) => {
            this._notificationI18n.info('NOTIFICATION.MESSAGE.EL_CORREO_DE_CONFIRMACION_SE_HA_REENVIADO_CON_EXITO');
            this.blockEnvioCorreo = false;
          },
          error: (error) => {

          }
        })
      },
      error: (error) => {

      }
    })
    
  }

  consultarStatus(): any {
      if (!this.currentUser.twoFactorEnabled) {
         this.tfActivated = false;
       } else {
         this.tfActivated = true;
       }
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption(isAllPage: Boolean) {
    if (isAllPage) {
      var url = new URL(window.location.href);
      url.searchParams.set('action', '20');
      window.location.href = url.href;
    } else {
      this._router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      }
      this._router.onSameUrlNavigation = 'reload';
      this.scrollTop()
      this._router.navigate(['/admin'], { queryParams: { action: 20 } });
    }
  }

  getTipoPersona() {
    return this._servicioGeneral.getTipoPersona()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TPersonas = data['TipoPersona'];
    });
  }

  getDocumentos() {
    return this._servicioGeneral.getTipoDocumento()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TDocumentos = data['TipoDocumento'];
    });
  }
  
  get documento() {
    return this.form.get("numero_documento");
  }

  getComunidades() {
    return this._servicioGeneral.getComunidades()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TComunidades = data['ComunidadAutonoma'];
    });
  }

  getProvincias() {
    return this._servicioGeneral.getProvincias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TProvincias = data['Provincia'];
    });
  }

  onChangeProvincia(event: Event) {
    this.TProvincias = [];
    const id = (event.target as HTMLInputElement).value;
    this.getProvinciasByID(id);
  }

  getProvinciasByID(id: string) {
    this.provincias
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      (data) => {
        data['Provincia'].forEach((provincia) => {
          if (provincia.ccaa["id"] == id) {
              this.TProvincias.push(provincia);
              return this.TProvincias;
            }
        });
      });
  }

  getMunicipios() {
    if(!this.direccion?.province["id"]){
      return this._servicioGeneral.getMunicipios()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
        this.TMunicipios = data;
      });
    }else{
      return this.getMunicipiosByID(this.direccion?.province["id"])
    }
  }

  onChangeMunicipio(event: Event) {
    this.TMunicipios = [];
    const id = (event.target as HTMLInputElement).value;
    this.getMunicipiosByID(id);
  }

  getMunicipiosByID(id: string) {
    this.municipios
      .pipe(takeUntil(this.destroy$))
      .subscribe( (data) =>{
      data['Municipio'].forEach((municipio) => {
        if(municipio.municipioPK["provincia"] == id){
          this.TMunicipios.push(municipio);
          return this.TMunicipios
        }
      });
    });
  }

  getVias() {
    return this._servicioGeneral.getTipoVias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TVias = data['TipoVia'];
    });
  }

  getPais() {
    return this._servicioGeneral.getPais()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TPais = data['Pais'];
    });
  }

  unsubscribeUser(){
    this.userService.unsubscribeCurrentUser(this.token)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: data => {
        if (data.status === "602") {
          this._notificationI18n.success('NOTIFICATION.MESSAGE.USUARIO_DADO_DE_BAJA_SE_PROCEDE_A_CERRAR_SESION', 50000);
          setTimeout(() => {
            this.logout();
          }, 5000);
        }
      },
      error: (err) => {
         if (err.error.status === "613") {
          this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_USUARIO_YA_ESTA_EN_ESTADO_DE_BAJA', 50000);
        }
        else{
          this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_REALIZAR_LA_BAJA_DEL_USUARIO', 50000);
        }
      }
    });
  }

  logout(): void {
    this.token.signOut();
    window.location.reload();
  } 

  
  openDeleteDialog() {
    const nombre = [this.currentUser?.nombre, this.currentUser?.apellido1].filter(Boolean).join(' ');
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: this.translate.instant('PROFILE.DEACTIVATE_TITLE'),
        message: this.translate.instant('PROFILE.DEACTIVATE_MESSAGE', { name: nombre }),
        confirmLabel: this.translate.instant('PROFILE.DEACTIVATE_CONFIRM')
      },
      panelClass: 'gu-dialog-panel'
    });
    return ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.unsubscribeUser();
      });
  }
  openValidateOtpMailDialog(tipoOtp: string) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = { titulo:  (tipoOtp == 'MOVIL'?"cambio de email":"cambio de teléfono movil") , tipo: tipoOtp}
    
    const dialogRef = this.dialog.open(ConfirmOtpDialogComponent, dialogConfig);
    
    return dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
      if (result.result == 'Confirmar') {
        this.updateMail(tipoOtp);
      }
    })
  }
  updateMail(tipoOtp: string){
    this._authService.updateUser(this.form.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({  
      next: async data => {
        if(tipoOtp == 'MOVIL'){
          this._notificationI18n.info('NOTIFICATION.MESSAGE.SE_HAN_REALIZADO_CORRECTAMENTE_LOS_CAMBIOS_SE_HA_ENVIADO_UN_MENSAJE_DE_CONFIRMAC', 50000);          
          this.token.saveToken(data.accessToken);
        }
        else{
          this._notificationI18n.info('NOTIFICATION.MESSAGE.SE_HA_HAN_REALIZADO_CORRECTAMENTE_LOS_CAMBIOS', 50000);         
        }
        this._usuarioService.getCurrentUserFromServer()
          .pipe(takeUntil(this.destroy$))
          .subscribe({
          next: async data => { 
            this.token.setUser(data.Usuario,data.usuarioRepresenta);
            
            this.isSignUpFailed = false;
            this.update = true;
            this.raiz.reloadHeader=!this.raiz.reloadHeader; 

            let reload = this._router.url.includes('action')?this._router.url.slice(1):this._router.url.slice(1).concat('?action=20')
            this._router.navigate(['inicio'], { skipLocationChange: true }).then(() => {
              this._router.navigateByUrl(reload);
            });
            
          },
          error: err => {
            //console.log(err);
            this.update = false;
            
            if(err.status == 226){
              this._notificationI18n.errorDynamic(err.error.text, 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            } 
  
            if(err.status == 406){
              this._notificationI18n.errorDynamic(err.error , 50000);
              this.form.controls['numero_documento'].setErrors({'incorrect': true});
            }
  
            if(err.error.status == 628){
              this._notificationI18n.errorDynamic(err.error , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }
  
            if(err.error.status == 627){
              this._notificationI18n.errorDynamic(err.error , 50000);
              this.form.controls['email'].setErrors({'incorrect': true});
            }
            this.isSignUpFailed = true;
          }
        });
      
      },
      error: err => {
        //console.log(err);
        this.update = false;
        
        if(err.status == 226){
          this._notificationI18n.errorDynamic(err.error.text, 50000);
          this.form.controls['numero_documento'].setErrors({'incorrect': true});
        } 

        if(err.status == 406){
          this._notificationI18n.errorDynamic(err.error , 50000);
          this.form.controls['numero_documento'].setErrors({'incorrect': true});
        }

        if(err.error.status == 628){
          this._notificationI18n.errorDynamic(err.error , 50000);
          this.form.controls['email'].setErrors({'incorrect': true});
        }

        if(err.error.status == 627){
          this._notificationI18n.errorDynamic(err.error , 50000);
          this.form.controls['email'].setErrors({'incorrect': true});
        }
        this.isSignUpFailed = true;
      }
    });    
  }
}